// extracted by mini-css-extract-plugin
module.exports = {"root":"FrontImage_root__nV9hB","title":"FrontImage_title__1sk_i"};